import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
// import { DisatanceReportComponent } from './disatance-report/disatance-report.component';

const routes: Routes = [
  // {
  //       path: 'distance-report', // child route path
  //       component: DisatanceReportComponent, // child route component that the router renders
  //  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ReportRoutingModule { }



// WEBPACK FOOTER //
// C:/vtrackOneqlik/oneqlik_wetrack/src/app/report/report-routing.module.ts